import { useState, useEffect } from "react";
import { CheckCircle } from "lucide-react";

const names = [
  "Carlos M.",
  "María G.",
  "José L.",
  "Ana P.",
  "Roberto S.",
  "Laura T.",
  "Miguel A.",
  "Carmen R.",
  "David H.",
  "Sofia V.",
  "Juan C.",
  "Patricia N.",
  "Eduardo F.",
  "Daniela M.",
  "Fernando O.",
];

const locations = [
  "Texas",
  "California", 
  "Florida",
  "New York",
  "Arizona",
  "Nevada",
  "Illinois",
  "New Jersey",
  "Colorado",
  "Georgia",
];

const times = [
  "hace 2 minutos",
  "hace 5 minutos",
  "hace 8 minutos",
  "hace 12 minutos",
  "hace 15 minutos",
];

const SocialProofNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: names[0],
    location: locations[0],
    time: times[0],
  });

  useEffect(() => {
    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      const randomTime = times[Math.floor(Math.random() * times.length)];

      setCurrentPurchase({
        name: randomName,
        location: randomLocation,
        time: randomTime,
      });

      setIsVisible(true);

      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };

    // Show first notification after 30 seconds
    const initialTimeout = setTimeout(showNotification, 30000);

    // Then show every 45-75 seconds
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 30000 + 45000);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);

  return (
    <div
      className={`fixed bottom-24 left-4 z-50 transition-all duration-500 ${
        isVisible
          ? "translate-x-0 opacity-100"
          : "-translate-x-full opacity-0"
      }`}
    >
      <div className="flex items-center gap-3 rounded-lg border border-primary/30 bg-card/95 backdrop-blur-sm px-4 py-3 shadow-lg max-w-[300px]">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-r from-primary to-accent">
          <CheckCircle className="h-5 w-5 text-white" />
        </div>
        <div className="flex flex-col">
          <p className="text-sm font-semibold text-white">
            {currentPurchase.name} <span className="text-white/60">de</span>{" "}
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              {currentPurchase.location}
            </span>
          </p>
          <p className="text-xs text-white/70">
            acaba de comprar • {currentPurchase.time}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SocialProofNotification;
